export const isPassengerChangeAffectingPrice = (previousPassenger, currentPassenger) => {
  if (previousPassenger.gender !== currentPassenger.gender) {
    return true;
  }
  return false;
};
